import slider from './pages/index';
import scrollbar from './pages/pages';
import newsList from './pages/news-list';
import leadership from "./pages/leadership";
import awards from "./pages/awards";
import "@fancyapps/fancybox";
import projects from "./pages/projects";
import project from "./pages/project";
import header from "./pages/header";
import contacts from "./pages/contacts";
import preloader from "./pages/preloader";
function init() {
	slider.init();
	scrollbar.init();
	newsList.init();
	leadership.init();
	awards.init();
	projects.init();
	project.init();
	header.init();
	contacts.init();
	preloader.init();

	$('[data-fancybox="gallery"]').fancybox();
}

init();
